import React from 'react';

const Arizona = () => {
  return (
    <div>
      
    </div>
  );
}

export default Arizona;
